export default __webpack_public_path__ + "static/media/desempleado.f5b0c228.jpeg";